import { StorefrontEnvironment } from '../types';

export const RECHARGE_API_URL = (environment: StorefrontEnvironment, environmentUri = ''): string => {
  switch (environment) {
    case 'prod':
      return 'https://api.rechargeapps.com';
    case 'stage':
      return 'https://api.stage.rechargeapps.com';
    case 'preprod':
    case 'prestage':
      return `${environmentUri}/api`;
  }
};
export const RECHARGE_ADMIN_URL = (environment: StorefrontEnvironment, environmentUri = ''): string => {
  switch (environment) {
    case 'prod':
      return 'https://admin.rechargeapps.com';
    case 'stage':
      return 'https://admin.stage.rechargeapps.com';
    case 'preprod':
    case 'prestage':
      return environmentUri;
  }
};
export const RECHARGE_CDN_URL = (environment: StorefrontEnvironment): string => {
  switch (environment) {
    case 'prod':
    case 'preprod':
      return 'https://static.rechargecdn.com';
    case 'stage':
    case 'prestage':
      return 'https://static.stage.rechargecdn.com';
  }
};
export const SHOPIFY_APP_PROXY_URL = '/tools/recurring';
